import React from 'react';
import { faqData } from './data';
import './FAQ.scss';

const FAQ=()=>{
    return(
        <div className="faq-part">
            <h1>Frequently asked questions</h1>
            <ul>
                {faqData.map((item) =>{
                    return(
                        <li>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
};
export default FAQ;